module.exports = __webpack_public_path__ + "img/wsc_logo.8af7de02.png";